// const config_json = {
//     'aws_appsync_graphqlEndpoint': "https://rwcrqyzgqrbwrgi6na76tpoflq.appsync-api.ap-south-1.amazonaws.com/graphql",
//     'aws_appsync_region': "ap-south-1",
//     'aws_appsync_authenticationType': "API_KEY",
//     'aws_appsync_apiKey': "da2-v5tyb52ou5eufk2vorni5o7azi",   
// }

// export default config_json;

const config_json = {
    API: {
      GraphQL: {
        endpoint: 'https://e5l6nrj6kfaw7hsemmp57ff6wi.appsync-api.ap-south-1.amazonaws.com/graphql',
        region: "ap-south-1",
        // Set the default auth mode to "apiKey" and provide the API key value
        defaultAuthMode: 'apiKey',
        apiKey: "da2-7sd3yudbfjgbflxfinwzn6r6xi"
      }
    }
    };
    
export default config_json;